import { isNumericId } from "./idValidation";

export const validateUserId = (id: string | number): boolean => {
	return isNumericId(id);
};

const userValidation = {
	validateUserId
};

export default userValidation;
